import { Box, Divider, Stack, Typography, useTheme, useMediaQuery, Button } from '@mui/material'
import { useDropzone } from 'react-dropzone'
import { UploadDocumentIcon } from '../../../../../components/icons'

interface UploadDropzoneProps {
  onDrop: (acceptedFiles: File[]) => void
  onBrowseClick: () => void
}

export const UploadDropzone = ({ onDrop, onBrowseClick }: UploadDropzoneProps) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: { 'image/*': ['.jpeg', '.jpg', '.png'] },
    maxFiles: 1,
  })

  return (
    <Box
      {...getRootProps()}
      sx={{
        border: '1px dashed #E2E8F0',
        borderRadius: 2.5,
        backgroundColor: 'white',
        p: 4,
        textAlign: 'center',
        gap: 2,
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack>
        <input {...getInputProps()} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            borderRadius: '50%',
            backgroundColor: theme.palette.background.default,
            height: '56px',
            width: '56px',
            justifyContent: 'center',
            margin: '0 auto',
          }}
        >
          <UploadDocumentIcon sx={{ color: 'transparent' }} />
        </Box>
        <Typography fontSize={'1rem'} fontWeight={'bold'} color={theme.palette.grey[600]} mt={1}>
          <span style={{ color: theme.palette.info.main }}>Click to upload</span>
          {!isMobile && ' or drag and drop'}
        </Typography>
        <Typography fontSize={'0.75rem'} fontWeight={'medium'} color={theme.palette.grey[400]}>
          SVG, PNG, JPG or GIF (max. 800x400px)
        </Typography>
      </Stack>

      <Divider
        sx={{
          '& .MuiDivider-wrapper': {
            color: `${theme.palette.grey[600]} !important`,
            fontWeight: 500,
          },
        }}
      >
        OR
      </Divider>
      <Button
        variant="contained"
        disableElevation onClick={onBrowseClick} sx={{ alignSelf: 'center' }}>
        Browse files
      </Button>
    </Box>
  )
}
